import { BRANDING } from "../config";

const Footer = () => {
  return (
    <div className="footer">
      {BRANDING.companyName} © {BRANDING.footerYear} | Powered by AI
    </div>
  );
};

export default Footer;
